import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "./Main";
import { TabContainer } from "../sub_components/Tabs";
import { SVGIcon } from "../wrappers/SVGIcon";

import { IStudentLayoutProps } from "../../interfaces/layouts";

import { Icons } from "../../data/Assets";

const StudentDetailsLayout = (props: IStudentLayoutProps) => {
  const { goBackRoute, operation, currentTab, title, error, children, linkedStatus, isStudentAdded } = props;
  const { isDataAvailable, linked } = linkedStatus;

  const navigate = useNavigate();

  const { studentId } = useParams();

  const tabItems = [
    { id: "Personal", label: "Personal" },
    { id: "Resume", label: "Resumes" },
    { id: "Cover-Letter", label: "Cover Letter" },
    { id: "Interviews", label: "Interviews" },
    { id: "Visa-Chances", label: "Visa-Chances" },
    { id: "Immigration", label: "Immigration" },
    { id: "Change-Log", label: "Change-Log" },
    { id: "Notifications", label: "Notifications" },
  ].map((tab) => ({
    ...tab,
    disabled: operation === "create" && tab.id !== "Personal",
  }));

  const handleTabChange = (tabId: string) => {
    if (tabId === currentTab || operation === "create") return;
    navigate(`/students/${studentId}/${tabId.toLowerCase()}`, {
      state: { goBackRoute: goBackRoute ?? "/students" },
    });
  };

  const renderActionButton = () => {
    if (!isStudentAdded) {
      return (
        <button className="immersion__btn immersion__btn__primary immersion__btn__primary__disabled">
          Invite
        </button>
      );
    }
    if (isDataAvailable && linked) {
      return (
        <button className="immersion__btn immersion__student_linked_btn">
          <span>Linked</span>
          <SVGIcon src={Icons.CheckCircleFill} color='success' />
        </button>
      );
    }
    return (
      <button className="immersion__btn immersion__btn__primary immersion__btn__primary__disabled">
        Invite
      </button>
    );
  };

  return (
    <MainLayout>
      <div className="immersion__common_details__layout">
        <div className="immersion__form_details__head">
          <h2 className="immersion__color__dark">{title}</h2>
          {renderActionButton()}
        </div>
        <div className="immersion__common_details__tabs__container">
          <TabContainer
            items={tabItems}
            activeTab={currentTab}
            onChange={handleTabChange}
            variant="navigation"
          />
        </div>
        <div className="immersion__common_details__content">
          {error ? (
            <div className="immersion__common_details__error_view">
              <br />
              <br />
              <h4 className="immersion__color__dark text_center">
                Error occurred while fetching the data.
              </h4>
              <h4 className="immersion__color__dark text_center">
                Please try again later.
              </h4>
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default StudentDetailsLayout;
